import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import '../../styles/BellonaMobilya.css';
import { FaWhatsapp, FaTimes } from "react-icons/fa";

const BellonaMobilya = () => {
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [isDetailOpen, setIsDetailOpen] = useState(false);
    
    const handleProductClick = (productId) => {
    // Ürün bilgisinin var olup olmadığını kontrol et
    if (products[productId]) {
      setSelectedProduct(productId);
      setIsDetailOpen(true);
      document.body.style.overflow = 'hidden'; // Scroll'u engelle
    } else {
      console.error('Ürün bulunamadı:', productId);
    }
  };

  const closeDetail = () => {
    setIsDetailOpen(false);
    setSelectedProduct(null);
    document.body.style.overflow = 'auto'; // Scroll'u geri aç
  };

    // Ürün bilgileri
  const products = {
    'estella-yatak-odasi': {
      name: 'Estella Yatak Odası Takımı',
      image: '../files/estella-yatak-odasi.webp',
      description: 'Estella, Bellona’nın 2025 yılı lansman ürünü. Zengin iç tasarım, fonksiyonel gardırop sistemleri, bronz ayna ve entegre mermer detayları ile sofistike ve zarif bir yatak odası takımı.',
      features: [
        'Zengin iç tasarım ve fonksiyonel gardırop',
        'Işıltılı bronz ayna detayları',
        'Entegre mermer detaylar',
        'Kadifemsi yüzeyler',
        'Elit metal ayaklar',
        'Estetik ve işlevsellik bir arada',
      ],
      dimensions: 'Modüler Sistem - Çeşitli Kombinasyonlar',
      material: 'Mermer detaylar, bronz ayna',
      delivery: 'Ücretsiz, Türkiye içi maksimum 45 gün',
      warranty: '2 Yıl Garanti',
      price: "98.325,00 ₺'den başlayan fiyatlarla",
    },
      'havana-yatak-odasi': {
        name: 'Havana Yatak Odası Takımı',
        image: '../files/havana-yatak-odasi.jpg',
        description: 'Modern ve klasik çizgilerin dengeli birleşimiyle sıcak, samimi ve lüks bir atmosfer. Takımda yatak, başlık, iki komodin, bir şifonyer ve bir gardırop bulunur.',
        features: [
          'Detaylı oyma işçilik',
          'Kaliteli ahşap yapılar',
          'Dayanıklı metal ayaklar',
          'Geniş aynalı gardırop',
          'Modern ve klasik tasarım dili',
          'Eksiksiz takım içeriği',
        ],
        dimensions: 'Modüler Sistem - Çeşitli Kombinasyonlar',
        material: 'Ahşap, metal ayaklar, ayna',
        warranty: '2 Yıl Garanti',
        price: "102.168,00 ₺'den başlayan fiyatlarla",
      },
      'boheems-yatak-odasi': {
        name: 'Boheems Yatak Odası Takımı',
        image: '../files/boheems-yatak-odasi.webp',
        description: 'Bohem dekorasyonun elegan ve işlevsel çizgileriyle, gardırop, baza, makyaj masası, komodin, şifonyer, markiz, yatak başlığı ve puftan oluşan eksiksiz bir takım.',
        features: [
          'Gardırop, baza, makyaj masası, komodin, şifonyer, markiz, yatak başlığı, puftan oluşan takım',
          'Gardırop üniteleri bazalı, diğer üniteler yüksek ayaklı',
          'Makyaj masası ve gardıropta bronz ayna',
          'Çekmece içlerinde gizli ray sistemi',
          'Yatak başlığı komodin arkasına uzanan saran yapı',
          'Gardırop içi raf ve askılama alanları',
          'Temizliği kolaylaştıran yüksek ayak yapısı',
        ],
        dimensions: 'Modüler Sistem - Çeşitli Kombinasyonlar',
        material: 'Ahşap, metal ayaklar, bronz ayna, gizli ray',
        warranty: '2 Yıl Garanti',
        price: "62.360,00 ₺'den başlayan fiyatlarla",
      },
    'larissa-yemek-odasi': {
      name: 'Larissa Yemek Odası Takımı',
      image: '../files/larissa-yemek-odasi.jpg',
      description: 'Beyaz rengin ferahlatıcı ve aydınlık etkisiyle, cam yüzeylerin geniş ortam illüzyonu yarattığı, fonksiyonel ve dekoratif bir yemek odası takımı.',
      features: [
        'Cam yüzeyli fonksiyonel bölümler',
        'Geniş saklama alanı',
        'Modern ve zarif tasarım',
        'Yüksek kaliteli malzeme',
        'Dekoratif ve fonksiyonel yaşam alanı',
      ],
      dimensions: 'Modüler Sistem - Çeşitli Kombinasyonlar',
      material: 'Yüksek kaliteli malzeme, cam yüzeyler',
      warranty: '2 Yıl Garanti',
      price: "99.799,00 ₺'den başlayan fiyatlarla",
    },
    'havana-yemek-odasi': {
      name: 'Havana Yemek Odası Takımı',
      image: '../files/havana-yemek-odasi.jpg',
      description: 'Modern ve klasik dokunuşların birleşimiyle zarif ve işlevsel bir yemek odası takımı. Geniş masa, 6 ergonomik sandalye ve şık vitrin ile hem konfor hem estetik sunar.',
      features: [
        'Geniş ve kullanışlı yemek masası',
        '6 adet ergonomik sandalye',
        'Şık vitrin (cam kapaklı, geniş iç hacimli)',
        'Modern ve klasik çizgilerin birleşimi',
        'Gri, kahve, beyaz renk seçenekleri',
        'Estetik sergileme ve depolama alanı',
      ],
      dimensions: 'Modüler Sistem - Çeşitli Kombinasyonlar',
      material: 'Ahşap, cam, kumaş minder',
      colors: 'Gri, kahve, beyaz',
      warranty: '2 Yıl Garanti',
      price: "84.063,00 ₺'den başlayan fiyatlarla",
    },
    'estella-yemek-odasi': {
      name: 'Estella Yemek Odası Takımı',
      image: '../files/estella-yemek-odasi.webp',
      description: 'Bellona Estella Yemek Odası Takımı ile sofralarınız artık yalnızca lezzetin değil, zarafetin de oyuncağı. Bej ve taş grisinin sıcak dokusu, mermer desenli yüzeyler ve altın şıklığında aksesuarlarla modern ve lüks bir atmosfer yaratır. 2025’in favorisi, estetik ve fonksiyonelliği buluşturuyor.',
      features: [
        'Bej ve taş grisi modern renkler',
        'Mermer desenli yüzeyler',
        'Altın şıklığında aksesuarlar',
        'Modern ve lüks atmosfer',
        'Estetik ve fonksiyonellik',
        '2025 Bellona lansman ürünü',
      ],
      dimensions: 'Modüler Sistem - Çeşitli Kombinasyonlar',
      material: 'Mermer desenli yüzeyler, altın aksesuarlar',
      colors: 'Bej, taş grisi',
      warranty: '2 Yıl Garanti',
      price: "91.076,00 ₺'den başlayan fiyatlarla",
    },
    'estella-koltuk-takimi': {
      name: 'Estella Koltuk Takımı',
      image: '../files/estella-koltuk-takimi.webp',
      description: 'Fırınlanmış gürgen iskelet, 1. kalite babyface kumaş, modern metal ayaklar ve farklı konfigürasyon seçenekleriyle Estella Koltuk Takımı hem dayanıklı hem konforlu. Üçlü koltuk, sehpalı koltuk, berjer ve tekli koltuk opsiyonları ile sipariş ve renk özelleştirmesi yapılabilir.',
      features: [
        'Fırınlanmış gürgen iskelet',
        'MDF destekli bölgeler',
        '1. kalite babyface kumaş',
        'Modern metal ayaklar',
        'Üçlü, sehpalı üçlü, berjer, tekli koltuk opsiyonları',
        'Renk ve sipariş özelleştirme',
      ],
      dimensions: 'Modüler Sistem - Çeşitli Kombinasyonlar',
      material: 'Fırınlanmış gürgen, metal ayak',
      warranty: '2 Yıl Garanti',
      price: "44.660,00 ₺'den başlayan fiyatlarla",
    },
    'boheems-koltuk-takimi': {
      name: 'Boheems Koltuk Takımı',
      image: '../files/boheems-koltuk-takimi.jpg',
      description: 'Ürün gövdesinde, son zamanların en çok tercih edilen kumaşları arasında yer alan nefes alabilen yapıda dokuma kumaş kullanılarak modern ve estetik bir görünüm sunulmuştur.',
      features: [
        'Nefes alabilen dokuma kumaş',
        'Dayanıklılığı artırılmış plastik ayaklar',
        'Uzun ömürlü iç konstrüksiyon',
        'İnsan sağlığına zarar vermeyen süngerler',
        'Yatak olabilen ikili koltuk',
        'Modern bohem tasarım',
      ],
      dimensions: 'Modüler Sistem - Çeşitli Kombinasyonlar',
      material: 'Metal iskelet, MDF, yonga levha',
      warranty: '2 Yıl Garanti',
      price: "35.471,00 ₺'den başlayan fiyatlarla",
    },
    'larissa-koltuk-takimi': {
      name: 'Larissa Koltuk Takımı',
      image: '../files/larissa-koltuk-takimi.webp',
      description: 'Larissa Koltuk Takımı, zarif tasarım detayları ve konforlu yapısıyla evinizi bir sanat eserine dönüştürüyor! Göz alıcı tasarımı ve rahatlık sunan yapısıyla bu takım, evinde şıklığı ve kaliteyi bir arada arayanlar için ideal bir seçim.',
      features: [
        'Nefes alabilen dokuma kumaş',
        'Dayanıklılığı artırılmış plastik ayaklar',
        'Uzun ömürlü iç konstrüksiyon',
        'İnsan sağlığına zarar vermeyen süngerler',
        'Yatak olabilen ikili koltuk',
        'Modern bohem tasarım',
      ],
      dimensions: 'Modüler Sistem - Çeşitli Kombinasyonlar',
      material: 'Kaliteli kumaş, dayanıklı plastik ayaklar',
      warranty: '2 Yıl Garanti',
      price: "58.123,00 ₺'den başlayan fiyatlarla",
    },
    'andera-genc-odasi': {
      name: 'Andera Genç Odası',
      image: '../files/andera-genc-odasi.webp',
      description: 'Takım modüler bir yapıya sahip; odanın gelişen ihtiyaçlarına göre kolayca yeniden düzenlenebilir. Genç büyüdükçe dekorasyonu değiştirmeden kullanıma devam edilebilir. Gardırobun kapaklarında bulunan ayna, hem işlevsel (özellikle giyinirken) hem de mekâna daha ferah bir görünüm kazandıran estetik bir öğedir. Kullanılan malzemeler dayanıklı ve uzun ömürlü olacak şekilde seçilmiştir; modern, şık tasarım ve kaliteli malzeme vurgusu yapılmıştır. Yatak başlığındaki zarif detaylar, komodin ve diğer parçalar ile oluşturulan uyumlu tasarım da öne çıkan teknik unsurlardandır.',
      features: [
        'Modüler ve yeniden düzenlenebilir takım',
        'Gardıropta işlevsel ve estetik ayna',
        'Dayanıklı ve uzun ömürlü malzeme',
        'Modern ve şık tasarım',
        'Komodin ve diğer parçalarda uyumlu tasarım',
        'İnsan sağlığına zarar vermeyen süngerler',
      ],
      dimensions: 'Modüler Sistem - Çeşitli Kombinasyonlar',
      material: 'Modern kaliteli ahşap',
      warranty: '2 Yıl Garanti',
      price: "58.392,00 ₺'den başlayan fiyatlarla",
    },
    'boheems-genc-odasi': {
      name: 'Boheems Genç Odası',
      image: '../files/boheems-genc-odasi.webp',
      description: 'Gençlerin hem dinlenirken hem de ders çalışırken kendini özgürce ifade edebileceği bir yaşam alanı… Boheems’in bohem esintisiyle harmanlanan şıklığı, fonksiyonelliği ve rahatlığı bir arada sunuyor!',
      features: [
        'Bohem esintili modern tasarım',
        'Fonksiyonel ve rahat kullanım',
        'Gençlerin özgürce ifade edebileceği alan',
        'Dinlenme ve çalışma için ideal',
        'Şık ve uyumlu detaylar',
      ],
      dimensions: 'Modüler Sistem - Çeşitli Kombinasyonlar',
      material: 'Modern kaliteli ahşap',
      warranty: '2 Yıl Garanti',
      price: "38.490,00 ₺'den başlayan fiyatlarla",
    },
    'valencia-genc-odasi': {
      name: 'Valencia Genç Odası',
      image: '../files/valencia-genc-odasi.webp',
      description: 'Valencia Genç Odası Takımı; modern, fonksiyonel ve estetik bir yaşam alanı sunar. Modüler yapısı sayesinde gençlerin değişen ihtiyaçlarına göre kolayca düzenlenebilir. Gardırop, başlık, çalışma masası ve kitaplık gibi modüller ile hem depolama hem de çalışma alanı sağlar. Gardırop kapaklarında bulunan ayna, mekâna ferahlık ve işlevsellik katar. Dayanıklı ve kaliteli malzemelerden üretilmiş olup, uzun ömürlü kullanım ve şık tasarım bir arada.',
      features: [
        'Modüler ve esnek kullanım',
        'Fonksiyonel depolama alanları',
        'Estetik ve işlevsel gardırop',
        'Çalışma masası ve kitaplık',
        'Dayanıklı ve kaliteli malzeme',
        'Modern ve şık tasarım',
        'Başlıkta zarif detaylar',
      ],
      dimensions: 'Modüler Sistem - Çeşitli Kombinasyonlar',
      material: 'Modern kaliteli ahşap',
      warranty: '2 Yıl Garanti',
      price: "41.110,00 ₺'den başlayan fiyatlarla",
    },

  }

  useEffect(() => {
    // URL'deki hash'i kontrol et ve ilgili bölüme scroll et
    if (window.location.hash) {
      const element = document.getElementById(window.location.hash.substring(1));
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
      }
    }
  }, []);
  return (
    <div className="bellona-mobilya">
      <Header />
      
      <main className="main-content">
        {/* Hero Section */}
        <section className="page-hero">
          <div className="hero-overlay"></div>
          <div className="hero-content">
            <div className="brand-logo">
              <img src="../files/bellona-logo.png" alt="Bellona Mobilya Logo" />
            </div>
            <h1>Bellona Mobilya Koleksiyonu</h1>
            <p>Modern tasarım ve üstün kalitede mobilya koleksiyonları</p>
          </div>
        </section>

        {/* Products Section */}
        <section className="products-section">
          <div className="container">
            <h2>Ürün Kategorilerimiz</h2>
            
            {/* Yatak Odası */}
            <div className="category-section" id="yatak-odasi">
              <h3 className="category-title">🛏️ Yatak Odası</h3>
              <div className="products-grid">
                <div className="product-card">
                  <div className="product-image">
                    <img src="../files/estella-yatak-odasi.webp" alt="Bellona Yatak Odası 1" />
                    <div className="product-overlay">
                      <button className="view-product" onClick={() => handleProductClick('estella-yatak-odasi')}>Detayları Gör</button>
                    </div>
                  </div>
                  <div className="product-info">
                    <h4>Estella Yatak Odası</h4>
                    <p>Zengin iç tasarım ve detayları ile sofistike ve fonksiyonel yatak odası takımı</p>
                    <div className="product-features">
                      <span className="feature">✓ Elit metal ayaklar</span>
                      <span className="feature">✓ Bronz Ayna & Mermer Detay</span>
                      <span className="feature">✓ Modern Tasarım</span>
                    </div>
                    <div className="product-price">
                      <span className="price">98.325,00 ₺</span>
                    </div>
                  </div>
                </div>

                <div className="product-card">
                  <div className="product-image">
                    <img src="../files/havana-yatak-odasi.jpg" alt="Bellona Yatak Odası 2" />
                    <div className="product-overlay">
                      <button className="view-product" onClick={() => handleProductClick('havana-yatak-odasi')}>Detayları Gör</button>
                    </div>
                  </div>
                  <div className="product-info">
                    <h4>Havana Yatak Odası</h4>
                    <p>Modern ve klasik çizgilerin birleşimiyle sıcak, samimi ve lüks bir atmosfer</p>
                    <div className="product-features">
                      <span className="feature">✓ Detaylı Oyma İşçilik</span>
                      <span className="feature">✓ Kaliteli Ahşap & Metal Ayaklar</span>
                      <span className="feature">✓ Geniş Aynalı Gardırop</span>
                    </div>
                    <div className="product-price">
                      <span className="price">102.168,00 ₺</span>
                    </div>
                  </div>
                </div>

                <div className="product-card">
                  <div className="product-image">
                    <img src="../files/boheems-yatak-odasi.webp" alt="Bellona Yatak Odası 3" />
                    <div className="product-overlay">
                      <button className="view-product" onClick={() => handleProductClick('boheems-yatak-odasi')}>Detayları Gör</button>
                    </div>
                  </div>
                  <div className="product-info">
                    <h4>Boheems Yatak Odası</h4>
                    <p>Bohem dekorasyonun elegan ve işlevsel çizgileriyle ferah bir yatak odası takımı</p>
                    <div className="product-features">
                      <span className="feature">✓ Bronz Ayna Detayı</span>
                      <span className="feature">✓ Yüksek Ayaklı Üniteler</span>
                      <span className="feature">✓ Gizli Ray Sistemi</span>
                    </div>
                    <div className="product-price">
                      <span className="price">62.360,00 ₺</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Yemek Odası */}
            <div className="category-section" id="yemek-odasi">
              <h3 className="category-title">🍽️ Yemek Odası</h3>
              <div className="products-grid">
                <div className="product-card">
                  <div className="product-image">
                    <img src="../files/larissa-yemek-odasi.jpg" alt="Bellona Yemek Odası 1" />
                    <div className="product-overlay">
                      <button className="view-product" onClick={() => handleProductClick('larissa-yemek-odasi')}>Detayları Gör</button>
                    </div>
                  </div>
                  <div className="product-info">
                    <h4>Larissa Yemek Odası</h4>
                    <p>Beyaz rengin ferahlatıcı etkisiyle fonksiyonel bir yemek odası takımı</p>
                    <div className="product-features">
                      <span className="feature">✓ Cam Yüzeyli Fonksiyonel Bölümler</span>
                      <span className="feature">✓ Geniş Saklama Alanı</span>
                      <span className="feature">✓ Modern & Zarif Tasarım</span>
                    </div>
                    <div className="product-price">
                      <span className="price">99.799,00 ₺</span>
                    </div>
                  </div>
                </div>

                <div className="product-card">
                  <div className="product-image">
                    <img src="../files/havana-yemek-odasi.jpg" alt="Bellona Yemek Odası 2" />
                    <div className="product-overlay">
                      <button className="view-product" onClick={() => handleProductClick('havana-yemek-odasi')}>Detayları Gör</button>
                    </div>
                  </div>
                  <div className="product-info">
                    <h4>Havana Yemek Odası</h4>
                    <p>Modern ve klasik dokunuşlarla zarif ve işlevsel bir yemek odası takımı</p>
                    <div className="product-features">
                      <span className="feature">✓ Geniş ve kullanışlı masa</span>
                      <span className="feature">✓ 6 Ergonomik Sandalye</span>
                      <span className="feature">✓ Cam Kapaklı Şık Vitrin</span>
                    </div>
                    <div className="product-price">
                      <span className="price">84.063,00 ₺</span>
                    </div>
                  </div>
                </div>

                <div className="product-card">
                  <div className="product-image">
                    <img src="../files/estella-yemek-odasi.webp" alt="Bellona Yemek Odası 3" />
                    <div className="product-overlay">
                      <button className="view-product" onClick={() => handleProductClick('estella-yemek-odasi')}>Detayları Gör</button>
                    </div>
                  </div>
                  <div className="product-info">
                    <h4>Estella Yemek Odası</h4>
                    <p>Mermer desenli yüzeyler ve altın şıklığında modern ve lüks bir atmosfer</p>
                    <div className="product-features">
                      <span className="feature">✓ Mermer Desenli Yüzeyler</span>
                      <span className="feature">✓ Altın Şıklığında Aksesuarlar</span>
                      <span className="feature">✓ Modern & Lüks Atmosfer</span>
                    </div>
                    <div className="product-price">
                      <span className="price">91.076,00 ₺</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Koltuk Takımı */}
            <div className="category-section" id="koltuk-takimi">
              <h3 className="category-title">🛋️ Koltuk Takımı</h3>
              <div className="products-grid">
                <div className="product-card">
                  <div className="product-image">
                    <img src="../files/estella-koltuk-takimi.webp" alt="Bellona Koltuk Takımı 1" />
                    <div className="product-overlay">
                      <button className="view-product" onClick={() => handleProductClick('estella-koltuk-takimi')}>Detayları Gör</button>
                    </div>
                  </div>
                  <div className="product-info">
                    <h4>Estella Koltuk Takımı</h4>
                    <p>Fırınlanmış gürgen iskelet, modern metal ayaklarla hem dayanıklı hem konforlu</p>
                    <div className="product-features">
                      <span className="feature">✓ Fırınlanmış Gürgen İskelet</span>
                      <span className="feature">✓ Babyface Kumaş</span>
                      <span className="feature">✓ Modern Metal Ayak</span>
                    </div>
                    <div className="product-price">
                      <span className="price">44.660,00 ₺</span>
                    </div>
                  </div>
                </div>

                <div className="product-card">
                  <div className="product-image">
                    <img src="../files/boheems-koltuk-takimi.jpg" alt="Bellona Koltuk Takımı 2" />
                    <div className="product-overlay">
                      <button className="view-product" onClick={() => handleProductClick('boheems-koltuk-takimi')}>Detayları Gör</button>
                    </div>
                  </div>
                  <div className="product-info">
                    <h4>Boheems Koltuk Takımı</h4>
                    <p>Uzun ömürlü, modern bohem tasarım ve konforlu oturum imkanı</p>
                    <div className="product-features">
                      <span className="feature">✓ Uzun ömürlü iç konstrüksiyon</span>
                      <span className="feature">✓ İnsan sağlığına zarar vermeyen süngerler</span>
                      <span className="feature">✓ Yatak olabilen ikili koltuk</span>
                    </div>
                    <div className="product-price">
                      <span className="price">35.471,00 ₺</span>
                    </div>
                  </div>
                </div>

                <div className="product-card">
                  <div className="product-image">
                    <img src="../files/bellona-mobilya.webp" alt="Bellona Koltuk Takımı 3" />
                    <div className="product-overlay">
                      <button className="view-product" onClick={() => handleProductClick('larissa-koltuk-takimi')}>Detayları Gör</button>
                    </div>
                  </div>
                  <div className="product-info">
                    <h4>Larissa Koltuk Takımı</h4>
                    <p>Evinizde lüks ve konforlu bir atmosfer yaratın</p>
                    <div className="product-features">
                      <span className="feature">✓ Zarif tasarım detayları</span>
                      <span className="feature">✓ Göz alıcı şıklık</span>
                      <span className="feature">✓ Konforlu oturum</span>
                    </div>
                    <div className="product-price">
                      <span className="price">58.123,00 ₺</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Genç Odası */}
            <div className="category-section" id="genc-odasi">
              <h3 className="category-title">👦🏻 Genç Odası</h3>
              <div className="products-grid">
                <div className="product-card">
                  <div className="product-image">
                    <img src="../files/andera-genc-odasi.webp" alt="Bellona Genç Odası 1" />
                    <div className="product-overlay">
                      <button className="view-product" onClick={() => handleProductClick('andera-genc-odasi')}>Detayları Gör</button>
                    </div>
                  </div>
                  <div className="product-info">
                    <h4>Andera Genç Odası</h4>
                    <p>Dayanıklı ve estetik detaylarla gençler için uzun ömürlü ve şık bir yaşam alanı</p>
                    <div className="product-features">
                      <span className="feature">✓ Modüler takım</span>
                      <span className="feature">✓ Dayanıklı malzeme</span>
                      <span className="feature">✓ Modern tasarım</span>
                    </div>
                    <div className="product-price">
                      <span className="price">58.392,00 ₺</span>
                    </div>
                  </div>
                </div>

                <div className="product-card">
                  <div className="product-image">
                    <img src="../files/boheems-genc-odasi.webp" alt="Bellona Genç Odası 2" />
                    <div className="product-overlay">
                      <button className="view-product" onClick={() => handleProductClick('boheems-genc-odasi')}>Detayları Gör</button>
                    </div>
                  </div>
                  <div className="product-info">
                    <h4>Boheems Genç Odası</h4>
                    <p>Bohem esintisiyle şıklık, fonksiyonellik ve rahatlık bir arada</p>
                    <div className="product-features">
                      <span className="feature">✓ Fonksiyonel ve rahat</span>
                      <span className="feature">✓ Dinlenme ve çalışma için ideal</span>
                      <span className="feature">✓ Şık detaylar</span>
                    </div>
                    <div className="product-price">
                      <span className="price">38.490,00 ₺</span>
                    </div>
                  </div>
                </div>

                <div className="product-card">
                  <div className="product-image">
                    <img src="../files/valencia-genc-odasi.webp" alt="Bellona Genç Odası 3" />
                    <div className="product-overlay">
                      <button className="view-product" onClick={() => handleProductClick('valencia-genc-odasi')}>Detayları Gör</button>
                    </div>
                  </div>
                  <div className="product-info">
                    <h4>Valencia Genç Odası</h4>
                    <p>Modern, fonksiyonel ve estetik yaşam alanı</p>
                    <div className="product-features">
                      <span className="feature">✓ Modüler ve esnek kullanım</span>
                      <span className="feature">✓ Çalışma masası ve kitaplık</span>
                      <span className="feature">✓ Dayanıklı malzeme</span>
                    </div>
                    <div className="product-price">
                      <span className="price">41.110,00 ₺</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Features Section */}
        <section className="features-section">
          <div className="container">
            <h2>Bellona Mobilya Avantajları</h2>
            <div className="features-grid">
              <div className="feature-item">
                <div className="feature-icon">🏆</div>
                <h3>Premium Kalite</h3>
                <p>En kaliteli malzemeler ve üstün işçilik</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">🎨</div>
                <h3>Modern Tasarım</h3>
                <p>Çağdaş ve şık tasarım anlayışı</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">🛡️</div>
                <h3>Uzun Ömürlü</h3>
                <p>Dayanıklı yapı ile yıllar boyu kullanım</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">🚚</div>
                <h3>Ücretsiz Teslimat</h3>
                <p>Adresinize kadar ücretsiz teslimat</p>
              </div>
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <section className="contact-section">
          <div className="container">
            <div className="contact-content">
              <h2>Daha Fazlası İçin Bizimle İletişime Geçin</h2>
              <p>Bellona Mobilya ürünleri hakkında detaylı bilgi almak ve fiyat teklifi için bize ulaşın.</p>
              <div className="contact-buttons">
                <a href="tel:+905496250335" className="btn btn-primary">📞 Hemen Ara</a>
                <a href="https://wa.me/905496250335" target="_blank" rel="noopener noreferrer" className="btn btn-secondary">
                  <FaWhatsapp style={{ marginRight: 8, fontSize: 20, verticalAlign: 'middle' }} />
                  WhatsApp
                </a>
                <Link to="/kurumsal" className="btn btn-outline">🏪 Mağazamızı Ziyaret Edin</Link>
              </div>
            </div>
          </div>
        </section>
      </main>

      {/* Product Detail Modal */}
      {isDetailOpen && selectedProduct && products[selectedProduct] && (
        <div className="product-detail-modal">
          <div className="modal-overlay" onClick={closeDetail}></div>
          <div className="modal-content">
            <button className="close-button" onClick={closeDetail}>
              <FaTimes />
            </button>
            
            <div className="modal-body">
              <div className="product-image-section">
                <img 
                  src={products[selectedProduct]?.image || '../files/traverta-yatak-odasi.webp'} 
                  alt={products[selectedProduct]?.name || 'Ürün'}
                  className="detail-image"
                />
              </div>
              
              <div className="product-info-section">
                <h2>{products[selectedProduct]?.name || 'Ürün Adı'}</h2>
                <p className="product-description">{products[selectedProduct]?.description || 'Açıklama bulunamadı'}</p>
                
                <div className="product-details">
                  <h3>Özellikler</h3>
                  <ul className="features-list">
                    {(products[selectedProduct]?.features || []).map((feature, index) => (
                      <li key={index}>✓ {feature}</li>
                    ))}
                  </ul>
                  
                  <div className="specifications">
                    <h3>Teknik Özellikler</h3>
                    <div className="spec-item">
                      <strong>Boyutlar:</strong> {products[selectedProduct]?.dimensions || 'Belirtilmemiş'}
                    </div>
                    <div className="spec-item">
                      <strong>Malzeme:</strong> {products[selectedProduct]?.material || 'Belirtilmemiş'}
                    </div>
                    <div className="spec-item">
                      <strong>Garanti:</strong> {products[selectedProduct]?.warranty || 'Belirtilmemiş'}
                    </div>
                    <div className="spec-item price">
                      <strong>Fiyat:</strong> {products[selectedProduct]?.price || 'Fiyat için iletişime geçin'}
                    </div>
                  </div>
                  
                  <div className="action-buttons">
                    <a href="tel:+905496250335" className="btn btn-primary">
                      📞 Fiyat Bilgisi Al
                    </a>
                    <a href="https://wa.me/905496250335" target="_blank" rel="noopener noreferrer" className="btn btn-secondary">
                      <FaWhatsapp style={{ marginRight: 8 }} size={25}/>
                      WhatsApp
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default BellonaMobilya;
